import { action, batch } from '@reatom/framework'

import { initializeBasicPollingReaction } from '@root/entities/basic'
import { currencyAddLogoEvent } from '@root/entities/currency/atoms'
import { initializeNetworkDataPoolingReaction } from '@root/entities/network'
import { prefetchUrlPairAction } from '@root/entities/pair/atoms'
import { initializePlatformAction } from '@root/entities/platform'
import { openPremiumCurrencyDetailsEvent } from '@root/entities/premium/atoms'
import { initializeWalletAtoms } from '@root/entities/wallet'
import { initializeWebSignInAction } from '@root/features/auth/web-sign-in'
import { initializeBlacklistCurrencies } from '@root/features/blacklist/blacklist-currencies/atoms'
import { initializeFavoritePairsAction } from '@root/features/favorite-pairs'
import {
  onInitializationReadyAction,
  onInitializationReadyOrWebsiteAction,
} from '@root/features/initialization/atoms/common'
import { initializeInitializationAction } from '@root/features/initialization/atoms/mobile'
import { initializeHeliusRpcLinksAction } from '@root/features/network/atoms'
import { initializeOrdersSocketAction } from '@root/features/orders/atoms'
import { initializeNativePricesAction } from '@root/features/realtime/atoms'
import { joinReferralCodeReaction } from '@root/features/referral/atoms'
import { initializeApplicationRouting } from '@root/features/routing/atoms'
import {
  PremiumCurrencyRoute,
  PremiumRoute,
} from '@root/features/routing/model'
import { initializeBlockhashAction } from '@root/features/services/blockhash/atoms'
import {
  dependenciesAtom,
  initializeDependencies,
} from '@root/features/shared/dependencies'
import { initializePositionSocketDataAction } from '@root/features/trade/position/atoms'
import { initializeTradeSettingsAction } from '@root/features/trade/trade-settings'
import {
  initializeTradingAction,
  initializeTradingWalletAction,
} from '@root/features/trade/trading'
import { initializeWalletTrackerAction } from '@root/features/wallet-tracker/atoms'
import { listenActivityState } from '@root/shared/lib'
import { routerActions } from '@root/shared/lib/react-router'

import {
  initializeMessaging,
  initializeOptionsDialogOpen,
  initializePremiumFlowsAction,
  initializeReferralCodeProfileUpdate,
} from './initialize-common'

export const initializeMobileAppAction = action(async (ctx) => {
  initializeDependencies(ctx)

  /** See the note in `initialize-desktop-app.ts`: the url already knows. */
  prefetchUrlPairAction(ctx)

  initializeApplicationRouting(ctx)
  initializePlatformAction(ctx)
  initializeHeliusRpcLinksAction(ctx)
  initializeTradingAction(ctx)
  initializeNetworkDataPoolingReaction(ctx)
  initializeBasicPollingReaction(ctx)
  initializeWebSignInAction(ctx)
  initializeNativePricesAction(ctx)
  initializeBlockhashAction(ctx)
  listenActivityState(ctx)
  initializeWalletTrackerAction(ctx)
  initializeFavoritePairsAction(ctx)
  initializePremiumFlowsAction(ctx)
  initializeBlacklistCurrencies(ctx)

  onInitializationReadyOrWebsiteAction(ctx, () => {
    const { mainWebsocket, chartWebsocket, pathfinderWsClient } =
      ctx.get(dependenciesAtom)
    batch(ctx, () => {
      mainWebsocket.initializeSocketAction(ctx)
      chartWebsocket.initializeAction(ctx)
      pathfinderWsClient.openSocket()
    })
  })

  onInitializationReadyAction(ctx, () => {
    batch(ctx, () => {
      initializeWalletAtoms(ctx)
      initializeTradingWalletAction(ctx)
      initializeTradeSettingsAction(ctx)
      initializePositionSocketDataAction(ctx)
      initializeOrdersSocketAction(ctx)
    })
  })

  initializeInitializationAction(ctx)
  initializeMessaging(ctx)
  joinReferralCodeReaction(ctx)
  initializeReferralCodeProfileUpdate()
  initializeOptionsDialogOpen()

  openPremiumCurrencyDetailsEvent.onCall((ctx, _, [{ currencyAddress }]) => {
    routerActions.navigate(
      ctx,
      PremiumCurrencyRoute.build({ currency: currencyAddress }),
    )
  })
  currencyAddLogoEvent.onCall((ctx, _currency) => {
    // TODO: Check flow
    routerActions.navigate(ctx, PremiumRoute.build())
  })
}, 'initializeMobileAppAction')
